import styles from './index.module.less';
import Image from 'next/image';
import dayjs from 'dayjs';
import Link from 'next/link';

const Index: React.FC<any> = ({ data }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{data.contentInfo['sction-buttom'].title}</h2>
      <div className={styles.desc}>{data.contentInfo['sction-buttom'].desc}</div>
      <ul className={styles.list}>
        {data.pageList?.map((item: any, index: number) => (
          <li className={styles.item} key={item.id}>
            <Link href={item.url_path} prefetch={false} title={item.title}>
              <Image src={item.cover_image} alt={item.title} width={500} height={312} />
              <div>
                <h3 className={styles.title}>{item.title}</h3>
                <div>{dayjs(item.date).format('MMMM D, YYYY')}</div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;
